export default [
    {
        path: '/page', // 登录
        component: resolve => require(['@/pages/wxmp/direct'], resolve),
        name: '首页'
    },
    {
        path: '/mobile', // 登录
        component: resolve => require(['@/pages/wxmp/mobile'], resolve),
        name: '首页'
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/wxmp.js